import React from "react";
import Ul from "../../components/list/Ul";
import Li from "../../components/list/Li";

const ListItems = ({ items, className = "text-gray-100" }) => {
  return (
    <Ul className="">
      {items.map((item, idx) => (
        <Li
          key={idx}
          className={` ${className}  font-semibold text-xl leading-relaxed list-disc`}
          text={item}
        />
      ))}
    </Ul>
  );
};

export default ListItems;
